import './index.css';
import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import styles from './compact-progress-indicator.module.scss.js';
import CompactStepIndicatorItem from './compact-step-indicator-item.js';

const CompactProgressIndicator = (props) => {
    const { surface, items, labelPosition = 'bottom', orientation = 'horizontal' } = props, rest = __rest(props, ["surface", "items", "labelPosition", "orientation"]);
    const progressIndicatorStyles = [styles.progressIndicator];
    if (orientation === 'vertical')
        progressIndicatorStyles.push(styles.vertical);
    const _renderItems = () => items === null || items === void 0 ? void 0 : items.map((section, i) => {
        const _calculateMinHeight = () => {
            if (orientation === 'vertical' && items.length === 1) {
                return section.minHeight;
            }
            if (orientation === 'vertical' && items.length > 1) {
                return '44px';
            }
            return undefined;
        };
        return (jsx(CompactStepIndicatorItem, Object.assign({ surface: surface, orientation: orientation, hideTrack: i === items.length - 1 }, section, { selected: section.selected, label: Object.assign(Object.assign({ showBottomPadding: true }, section.label), { position: labelPosition }), minHeight: _calculateMinHeight() }), i));
    });
    return (jsx("div", Object.assign({}, rest, { className: progressIndicatorStyles.join(' '), children: items && _renderItems() })));
};

export { CompactProgressIndicator as default };
